// extracted by mini-css-extract-plugin
export var cell = "MetricsStrip-module--cell--36ff2";
export var label = "MetricsStrip-module--label--85509";
export var number = "MetricsStrip-module--number--c11ef";
export var strip = "MetricsStrip-module--strip--c6a94";